// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CheckoutHeader_wrapper__0Qrm7","header":"CheckoutHeader_header__iy09Q","logo":"CheckoutHeader_logo__dY3KD","support":"CheckoutHeader_support__GYWeq"};